export enum GuestCategoryDisplayTypeEnum {
    Business = 'Business',
    Solo = 'Solo',
    Couple = 'Couple',
    Family = 'Family',
    Friends = 'Friends',
}
